// extracted by mini-css-extract-plugin
export default {"textarea":"textarea-D8nhQ","disabled":"disabled-W6DGY"};